module.exports = __webpack_public_path__ + "img/ens-manager.7b7ba215.svg";